// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { compactHeaderStyles } from "@guestsupply/Overrides/Pages/CompactHeader";
import { xScreen } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

compactHeaderStyles.headerLinkListWrapper = {
    css: css`
        &&&& {
            padding: 0;
        }
        .list-wrapper {
            display: flex;
            flex-wrap: nowrap;
        }
    `,
};
compactHeaderStyles.itemsWrapper = {
    css: css`
        flex-grow: 1;
    `,
};
compactHeaderStyles.rightSectionWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 24px;
        margin-left: 12px;
    `,
};
compactHeaderStyles.mainNavigationWrapper = {
    css: css`
        &&&& {
            padding: 0;
        }
    `,
};
compactHeaderStyles.navigationAndLinkedListWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin: 0 -16px;
        width: calc(100% + 32px);
    `,
};
compactHeaderStyles.wrapper = {
    css: css`
        width: 100%;
        background-color: ${getColor("common.background")};
        position: relative;
        z-index: inherit;
    `,
};
compactHeaderStyles.closeMenuClickable = {
    css: css`
        width: 34px;
        height: 40px;
        justify-content: center;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
